import { Box, Typography, useTheme } from "@mui/material";
import React from "react";

type DealsPageEmptyStateProps = {
  title: string;
  content: string;
};
export const DealsPageEmptyState = ({
  title,
  content,
}: DealsPageEmptyStateProps) => {
  const theme = useTheme();

  return (
    <Box
      width={"100%"}
      height={"188px"}
      position={"relative"}
      boxSizing={"border-box"}
      padding={"36px 0 28px"}
      border={`1px solid ${theme.palette.tertiary.light}`}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      marginTop={"12px"}
    >
      <Box display={"flex"} alignItems={"center"} flexDirection={"column"}>
        <Box marginBottom={"4px"}>
          <Typography data-testid={"empty-state-title"} variant={"subtitle2"}>
            {title}
          </Typography>
        </Box>
        <Box width={"667px"} textAlign={"center"}>
          <Typography data-testid={"empty-state-content"} variant={"body2"}>
            {content}
          </Typography>
        </Box>
        <Box
          width={"96px"}
          height={"53px"}
          position={"absolute"}
          top={"-8px"}
          right={"58px"}
        >
          <img src={"/assets/hint-point-up.svg"} />
        </Box>
      </Box>
    </Box>
  );
};
